


























import { Component, Vue, Prop } from 'nuxt-property-decorator';

import ClickOutside from '@/directives/click_outside';
import { Directions, Positions } from '@/components/common/Dropdown/types';

const DROPDOWN_MENU_LEFT_PADDING = 16;

@Component<Dropdown>({
  name: 'Dropdown',
  directives: { ClickOutside },
  watch: {
    opened(newValue) {
      if (newValue) {
        this.adjustPosition();
      }

      this.$emit('toggle', newValue);
    },
    isVisible(newValue) {
      this.opened = newValue;
    },
  },
})
export default class Dropdown extends Vue {
  @Prop({ default: '' }) menuClass!: string;
  @Prop({ default: true }) autoClose!: boolean;
  @Prop({ default: false }) fullScreenOnMobile!: boolean;
  @Prop({ default: false }) isVisible!: boolean;
  @Prop({ default: false }) controlFromParent!: boolean;
  @Prop({ default: false }) preventAnimation!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: Positions.Left }) position!: Positions;
  @Prop({ default: Directions.Bottom }) direction!: Directions;

  protected opened: boolean = this.isVisible;

  get menuClassName() {
    return [
      {
        'dropdown__menu--right': this.position === Positions.Right,
        'dropdown__menu--top': this.direction === Directions.Top,
        'dropdown__menu--full-screen-mobile': this.fullScreenOnMobile && this.$device.isMobile,
      },
      this.menuClass,
    ];
  }

  adjustPosition() {
    this.$nextTick(() => {
      const dropdownMenuElement = this.$el.querySelector('.dropdown__menu') as HTMLElement;
      const parentRect = this.$el.getBoundingClientRect();
      const dropdownMenuElementRect = dropdownMenuElement?.getBoundingClientRect();

      if (this.position === Positions.Right && (dropdownMenuElementRect?.x ?? 0) < 0) {
        Object.assign(dropdownMenuElement?.style, {
          right: 'auto',
          left: `${-parentRect.x + DROPDOWN_MENU_LEFT_PADDING}px`,
        });
      }
    });
  }

  handleToggle() {
    if (this.controlFromParent || this.disabled) return;

    this.opened = !this.opened;
  }

  handleClose() {
    this.$emit('on-close');

    this.opened = false;
  }

  onOuterClickOutside() {
    if (!this.autoClose) {
      this.handleClose();
    }
  }

  onInnerClickOutside() {
    if (this.autoClose) {
      this.handleClose();
    }
  }
}
